<template lang="html">
  <div class="contact_wrap">

    <div class="contact_main_title">
      <h1>Contact</h1>
    </div>

    <div class="contact_info_container">
      <div class="contact_info_justi">
        <div class="contact_info_section">
          <div class="contact_info_section_head">
            <h1 class="location_icon">Adres</h1>
          </div>
          <div class="contact_info_section_content">
            <h1>Zijdelveld 34-35, 1421 TJ Uithoorn</h1>
          </div>
        </div>
        <div class="contact_info_section">
          <div class="contact_info_section_head">
            <h1 class="call_icon">Altijd bereikbaar</h1>
          </div>
          <div class="contact_info_section_content">
            <a class="callto" href="callto:0297-564092">0297-564092</a>
            <a class="callto" href="callto:0297-540055">0297-540055</a>
          </div>
        </div>
        <div class="contact_info_section">
          <div class="contact_info_section_head">
            <h1 class="mail_icon">E-mailadres</h1>
          </div>
          <div class="contact_info_section_content">
            <a class="mailto" href="mailto:vanden.wijngaart@hetnet.nl">vanden.wijngaart@hetnet.nl</a>
          </div>
        </div>
      </div>
    </div>
    <div class="contact_form_container">

      <transition name="fade" mode="out-in">
        <div class="contact_form_succes" v-if="mailSend == true">
          <div class="contact_succes_wrap">
            <div class="contact_succes_icon">
              <i class="fas fa-paper-plane icon_plane"></i>
              <i class="fas fa-check icon_check"></i>
              <div class="icon_circle"></div>
            </div>
            <h1>Bedankt voor uw aanvraag!</h1>
            <p>De aanvraag is succesvol verzonden, wij geven u zo snel mogelijk antwoord.</p>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="form" v-if="mailSend == false">

          <transition name="fadeInTop" mode="out-in">
            <div class="form_melding_wrap" v-if="mailMelding">
              <div class="form_melding_container" @click="mailMelding = null">
                <h1>{{ mailMelding }}</h1>
              </div>
            </div>
          </transition>

          <div class="input_container">
            <div class="input" v-bind:class="{labelFull: voornaamCss}">
              <input id="voornaam" v-model="voornaam" type="text" name="voornaam">
              <label for="voornaam">Voornaam *</label>
            </div>
            <div class="input" v-bind:class="{labelFull: achternaamCss}">
              <input id="achternaam" v-model="achternaam" type="text" name="achternaam">
              <label for="achternaam">Achternaam *</label>
            </div>
          </div>
          <div class="input" v-bind:class="{labelFull: emailCss}">
            <input id="email" v-model="email" type="email" name="email">
            <label for="email">E-mail *</label>
          </div>
          <div class="input" v-bind:class="{labelFull: telefoonCss}">
            <input id="telefoon" v-model="telefoon" type="number" name="telefoon">
            <label for="telefoon">Telefoon *</label>
          </div>
          <div class="input_container">
            <div class="input" v-bind:class="{labelFull: straatCss}">
              <input id="straat" v-model="straat" type="text" name="straat">
              <label for="straat">Straat *</label>
            </div>
            <div class="input" v-bind:class="{labelFull: huisnummerCss}">
              <input id="huisnummer" v-model="huisnummer" type="text" name="huisnummer">
              <label for="huisnummer">Huisnummer *</label>
            </div>
          </div>
          <div class="input_container">
            <div class="input" v-bind:class="{labelFull: postcodeCss}">
              <input id="postcode" v-model="postcode" type="text" name="postcode">
              <label for="postcode">Postcode *</label>
            </div>
            <div class="input" v-bind:class="{labelFull: plaatsCss}">
              <input id="plaats" v-model="plaats" type="text" name="plaats">
              <label for="plaats">Plaats *</label>
            </div>
          </div>
          <div class="textarea" v-bind:class="{labelTextFull: berichtCss}">
            <textarea name="bericht" v-model="bericht"></textarea>
            <label for="bericht">Bericht *</label>
          </div>
          <div class="input" style="margin: 0;">
            <button class="submit" @click="isFormValid()">Verzenden</button>
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import MailService from '../../MailService';
import axios from 'axios';

export default {
  data() {
    return{
      //form data
      voornaam: null, achternaam: null, email: null, telefoon: null, straat: null, huisnummer:null, postcode: null, plaats: null, bericht: null,
      //form css
      voornaamCss: false, achternaamCss: false, emailCss: false, telefoonCss: false, straatCss: false, huisnummerCss: false, postcodeCss: false, plaatsCss: false, berichtCss: false,
      //emailvalidator
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      //mail data
      mailSend: false, mailMelding: null,
    }
  },
  watch: {
    //check form data
    voornaam(val) {if(val == '') {this.voornaamCss = false;}else{this.voornaamCss = true;}}, achternaam(val) {if(val == '') {this.achternaamCss = false;}else{this.achternaamCss = true;}}, email(val) {if(this.reg.test(this.email)){this.emailCss = true;}else{this.emailCss = false;}},
    telefoon(val) {if(val == '') {this.telefoonCss = false}else{this.telefoonCss = true;}}, straat(val) {if(val == '') {this.straatCss = false;}else{this.straatCss = true;}}, huisnummer(val) {if(val == '') {this.huisnummerCss = false;}else{this.huisnummerCss = true;}},
    postcode(val) {if(val == '') {this.postcodeCss = false;}else{this.postcodeCss = true;}}, plaats(val) {if(val == '') {this.plaatsCss = false;}else{this.plaatsCss = true;}}, bericht(val) {if(val == '') {this.berichtCss = false;}else{this.berichtCss = true;}}
  },
  methods: {

    isFormValid() {
      if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.telefoon && this.straat && this.huisnummer && this.postcode && this.plaats && this.bericht){this.sendEmail();}
      else{
        if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.telefoon && this.straat && this.huisnummer && this.postcode && this.plaats){this.mailMelding = "Vul een bericht in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.telefoon && this.straat && this.huisnummer && this.postcode && this.bericht){this.mailMelding = "Vul uw plaats in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.telefoon && this.straat && this.huisnummer && this.plaats && this.bericht){this.mailMelding = "Vul uw postcode in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.telefoon && this.straat && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul uw huisnummer in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.telefoon && this.huisnummer && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul uw straat in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && this.reg.test(this.email) && this.straat && this.huisnummer && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul uw telefoonnummer in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && !this.reg.test(this.email) && this.telefoon && this.straat && this.huisnummer && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul een geldig e-mailadres in!";this.VerwijderMelding();}
        else if(this.voornaam && this.achternaam && this.email == '' && this.telefoon && this.straat && this.huisnummer && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul uw e-mail in!";this.VerwijderMelding();}
        else if(this.voornaam && this.telefoon && this.reg.test(this.email) && this.straat && this.huisnummer && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul uw achternaam in!";this.VerwijderMelding();}
        else if(this.achternaam && this.telefoon && this.reg.test(this.email) && this.straat && this.huisnummer && this.postcode && this.plaats && this.bericht){this.mailMelding = "Vul uw voornaam in!";this.VerwijderMelding();}
        else{this.mailMelding = "Vul alle verplichte velden in! (*)";this.VerwijderMelding();}
      }
    },

    VerwijderMelding() {
      setTimeout(function () {this.mailMelding = null;}.bind(this), 5000);
    },

    sendEmail() {
      let self = this
      axios.post('https://jvdwijngaart.nl:8080', {voornaam: this.voornaam, achternaam: this.achternaam, email: this.email, telefoon: this.telefoon, straat: this.straat, huisnummer: this.huisnummer, postcode: this.postcode, plaats: this.plaats, bericht: this.bericht
      })
      .then(function (response) {self.mailSend = true;console.log(response);})
      .catch(function (error) {self.mailMelding = error;self.VerwijderMelding();console.log(error);})
    }
  }
}
</script>

<style lang="css">

.form_melding_wrap{
  position: fixed;
  display: flex;
  justify-content: center;
  top: 70px;
  left: 25%;
  width: 100%;
  z-index: 200;
}

.form_melding_container{
  background: #fff;
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
  box-shadow: 1px 1px 8px rgba(0,0,0,0.1);
}

.form_melding_container h1{
  font-size: 15px;
  font-weight: 400;
  color: #ed4014;
  opacity: 0.8;
}

.contact_form_container .contact_form_succes .contact_succes_wrap h1{
  position: relative;
  font-size: 20px;
  font-weight: 900;
  font-family: 'Roboto', sans-serif;
  text-align: center;
  color: #222;
  margin-bottom: 20px;
  opacity: 0;
  animation: fadein3 0.5s ease 1 forwards;
}

.contact_form_container .contact_form_succes .contact_succes_wrap p{
  font-size: 15px;
  font-weight: 300;
  font-family: 'Roboto', sans-serif;
  color: #777;
  text-align: center;
  opacity: 0;
  animation: fadein3 0.5s ease 0.5s 1 forwards;
}

.contact_form_container .contact_form_succes .contact_succes_wrap .icon_plane{
  font-size: 30px;
  color: #222;
  bottom: 85px;
  position: absolute;
  opacity: 0;
  animation: fadein 1s ease 1 forwards;
}

.contact_form_container .contact_form_succes .contact_succes_wrap .icon_check{
  color: #19be6b;
  font-size: 30px;
  margin-left: 2px;
  bottom: 84px;
  position: absolute;
  opacity: 0;
  animation: fadein2 1s ease 0.5s 1 forwards;
}


.contact_succes_icon{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.contact_succes_icon .icon_circle{

}

@keyframes fadein3 {
  0% {opacity: 0;transform: translateY(20px);}
  100% {opacity: 1;transform:  translateY(0px);}
}

@keyframes fadein2 {
  0% {opacity: 0;transform: translateY(20px);}
  50% {opacity: 1;transform:  translateY(0px);}
  100% {opacity: 1;transform:  translateY(0px);}
}

@keyframes fadein {
  0% {opacity: 0;transform: translateY(20px);}
  50% {opacity: 1;transform:  translateY(0px);}
  65% {opacity: 0;transform: translateY(20px);}
  100% {opacity: 0;transform: translateY(20px);}
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.3s ease;
}

.fade-enter,
.fade-leave-active {
  transform: scale(0.98);
  opacity: 0;
}

.fadeInTop-enter-active,
.fadeInTop-leave-active {
  transition: 0.3s ease;
}

.fadeInTop-enter,
.fadeInTop-leave-active {
  transform: translateY(-10px);
  opacity: 0;
}

.contact_wrap{
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
}

.contact_info_container{
  width: 50%;
  height: auto;
  background:
    linear-gradient(
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.8)
    ),
    url('../../assets/banner/work1.jpg');
    background-position: center;
    background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact_info_justi{
  height: 70%;
  max-height: 400px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
}

.contact_info_section{

}

.contact_info_section_head h1{
  position: relative;
  font-size: 20px;
  font-weight: 900;
  font-family: 'Roboto', sans-serif;
  color: #fff;
  margin-bottom: 20px;
}

.contact_info_section_head h1::before{
  position: absolute;
  font-size: 20px;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  left: -40px;
}

.contact_info_section_head .location_icon::before{
  content: "\f7a2";
}

.contact_info_section_head .call_icon::before{
  content: "\f095";
}

.contact_info_section_head .mail_icon::before{
  content: "\f0e0";
}

.contact_info_section_content{
  display: flex;
  flex-direction: column;
}

.contact_info_section_content h1{
  font-size: 15px;
  font-weight: 300;
  font-family: 'Roboto', sans-serif;
  color: #bbb;
}

.contact_info_section_content a{
  font-size: 15px;
  font-weight: 300;
  font-family: 'Roboto', sans-serif;
  color: #bbb;
  text-decoration: none;
}

.contact_form_container{
  position: relative;
  width: 50%;
  min-height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact_form_container .contact_form_succes{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact_form_container .contact_form_succes .contact_succes_wrap{
  position: relative;
  width: 90%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.contact_form_container .form{
  width: 100%;
  padding: 25px;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.contact_form_container .form .input_container{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.contact_form_container .form .input_container .input{
  display: table;
  margin-bottom: 25px;
  width: 45%;
}

.contact_form_container .form .input{
  display: table;
  margin-bottom: 25px;
  width: 100%;
}

.contact_form_container .form .input label{
  display: table-header-group;
  font-size: 15px;
  font-weight: 400;
  color: #777;
  transform: translateY(30px);
  cursor: text;
  transition: 0.30s ease;
}

.contact_form_container .form .input input{
  display: table-row-group;
  width: 100%;
  height: 40px;
  border: none;
  outline: none;
  border-bottom: 1px solid #777;
  font-family: 'segoe UI', sans-serif;
  background-color: transparent;
  transition: 0.30s ease;
}

.contact_form_container .form .input .submit{
  width: 100%;
  height: 40px;
  background: #19be6b;
  border-radius: 5px;
  color: #fff;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 15px;
  opacity: 0.7;
  border: none;
  transition: 0.30s ease;
}

.contact_form_container .form .input .submit:hover{
  opacity: 1;
  cursor: pointer;
  transition: 0.30s ease;
}

.contact_form_container .form .input input:focus{
  border-bottom: 1px solid #2db7f5;
  transition: 0.30s ease;
}

.contact_form_container .form input:focus + label {
  color: #2db7f5;
  font-weight: 700;
  transform: translateY(0px);
  transition: 0.30s ease;
}

.contact_form_container .form .labelFull input + label {
  color: #19be6b;
  transform: translateY(0px);
  transition: 0.30s ease;
}

.contact_form_container .form .labelFull input{
  border-bottom: 1px solid #19be6b !important;
}

.contact_form_container .form .textarea{
  display: table;
  margin-bottom: 50px;
  width: 100%;
}

.contact_form_container .form .textarea label{
  display: table-header-group;
  font-size: 15px;
  font-weight: 400;
  color: #777;
  transition: 0.30s ease;
}

.contact_form_container .form .textarea textarea{
  display: table-row-group;
  width: calc(100% - 10px);
  min-height: 160px;
  border: none;
  outline: none;
  border-radius: 5px;
  background: #f1f1f1;
  margin-top: 10px;
  padding: 5px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 13px;
  font-weight: 400;
  transition: 0.35s ease;
}

.contact_form_container .form .labelTextFull label{
  color: #19be6b;
  font-weight: 700;
}

.contact_main_title{
  width: 100%;
  height: 100px;
  padding: 25px 0 25px 25px;
  display: none;
  align-items: center;
  box-sizing: border-box;
}

.contact_main_title h1{
  font-family: 'Segoe UI', sans-serif;
  font-size: 25px;
  font-weight: 800;
  line-height: 22px;
  color: #222;
  animation: titleanim 0.8s ease 1;
}



@media only screen and (max-width : 650px) {
  .contact_wrap{
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .contact_form_container{
    width: 100%;
    background:
      linear-gradient(
        rgba(255, 255, 255, 0.85),
        rgba(255, 255, 255, 0.85)
      ),
      url('../../assets/banner/work1.jpg');

  }

  .contact_info_container{
    width: 100%;
    padding: 50px 0px 50px 0px;
    display: none;
  }

  .contact_form_container .form .textarea textarea{
    background: #f9f9f9;
  }

  .form_melding_wrap{
    position: fixed;
    display: flex;
    justify-content: center;
    top: 100px;
    left: 0;
    width: 100%;
    z-index: 200;
  }

  .form_melding_container{
    background: #fff;
    padding: 10px 10px 10px 10px;
    border-radius: 5px;
    box-shadow: 1px 1px 8px rgba(0,0,0,0.1);
  }

  .contact_main_title{
    display: flex;
  }

}


</style>
